const Checkbox = ({ label, children, className = '', ...inputProps }) => (
    <label className={`custom-control custom-checkbox ${className}`}>
        <input className="custom-control-input" type="checkbox" {...inputProps} />
        <span className="custom-control-indicator" />
        {label ? (
            <span className="custom-control-description" dangerouslySetInnerHTML={{ __html: label }} />
        ) : (
            <span className="custom-control-description">{children}</span>
        )}
    </label>
)

export default Checkbox
